import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "~/components/ui/Link";
import { useCampaign } from "~/layouts/CampaignContext";
import { pushValueInQuery } from "~/helpers/URIhelper";

type SubHeaderProps = {
  officeLogo: string;
  officeName: string;
  officeUrl: string;
  serverSideScope: string;
  titleComp?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
};

const SubHeader = ({
  officeLogo,
  officeName,
  officeUrl,
  serverSideScope,
  titleComp = 'h1',
}: SubHeaderProps) => {
  const { campaign } = useCampaign();
  const officeBackUrl = pushValueInQuery(officeUrl, 'c', campaign?.campaignCode);
  const Comp = titleComp;

  return (
    <div className="mb-10">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3 w-[100%] lg:w-[65%]">
          {officeLogo && (
            <div className="w-[15%] lg:w-[10%] h-[3rem] lg:h-[4.5rem] rounded shadow-sm bg-white p-1">
              <img
                src={officeLogo}
                alt={`Logo van ${officeName}`}
                className="object-contain w-[100%] h-[100%] rounded"
              />
            </div>
          )}
          <Comp className="w-[85%] lg:w-[90%] text-base lg:text-3xl font-bold font-avantgarde">
            <span className="sr-only">{serverSideScope}</span>
            {officeName}
          </Comp>
        </div>
        <div className="hidden lg:flex">
          <Link
            variant="default"
            className="button--back"
            href={officeBackUrl}
          >
            <FontAwesomeIcon icon={faChevronLeft as IconProp} />
            Ga terug naar de kantoorpagina
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;